import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import SocketNoti from "socket";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
    // <React.StrictMode>
    <Provider store={store}>
        <SocketNoti>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </SocketNoti>
    </Provider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
